
import React  from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from 'react-router-dom';
// import styled from 'styled-components';
import './slider.css';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';

import slide_image_2 from '../img/shahdara sharif.jpg';
import slide_image_1 from '../img/noori chamb.jpeg';
import slide_image_3 from '../img/ragunathaji.jpg';
import slide_image_4 from '../img/Guraz 1.jpg';
import slide_image_5 from '../img/tattapani.jpg';
import slide_image_6 from '../img/adventure.jpg';
import slide_image_7 from '../img/chingus fort.jpg';




function Slider() {
 
  return (
    <div className="CustomStyleSlider ">
    {/* <Container> */}
      <h1 className="heading">Gallery</h1>
      <Swiper
        effect={'coverflow'}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        slidesPerView={'auto'}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: true,
        }}
        pagination={{ el: '.swiper-pagination', clickable: true }}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          clickable: true,
        }}
    
        modules={[EffectCoverflow, Pagination, Navigation]}
        className="swiper_container"
      >
        <SwiperSlide>
        
        <Link className="slider-link" to='/gallery' target="_blank" >
          <img src={slide_image_2} alt="slide_image" /> 
          <div className="slide-text">Pilgrimage     &      Sculpture </div>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
        <Link className="slider-link" to='/gallery' target="_blank" >
          <img src={slide_image_1} alt="slide_image" />
          <div className="slide-text">Eco Tourism</div>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
        <Link className="slider-link" to='/gallery' target="_blank" >
          <img src={slide_image_3} alt="slide_image" />
          <div className="slide-text">MICE</div>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
        <Link className="slider-link" to='/gallery' target="_blank" >
          <img src={slide_image_4} alt="slide_image" />
          <div className="slide-text">Border Tourism</div>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
        <Link className="slider-link" to='/gallery' target="_blank" >
          <img src={slide_image_5} alt="slide_image" />
          <div className="slide-text">Health          &        Wellness</div>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
        <Link className="slider-link" to='/gallery' target="_blank" >
          <img src={slide_image_6} alt="slide_image" />
          <div className="slide-text">Adventure</div>
          </Link>
        </SwiperSlide>
        <SwiperSlide>
        <Link className="slider-link" to='/gallery' target="_blank" >
          <img src={slide_image_7} alt="slide_image" />
          <div className="slide-text">Heritage</div>
          </Link>
        </SwiperSlide>
        <div className="slider-controler">
          <div className="swiper-button-prev slider-arrow">
            <ion-icon name="arrow-back-outline"></ion-icon>
          </div>
          <div className="swiper-button-next slider-arrow">
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </div>
          <div className="swiper-pagination"></div>
        </div>
      </Swiper>
      
      {/* </Container> */}
   </div>
  );
}

export default Slider;



















